import { render, staticRenderFns } from "./SistemaGrupoEdit.vue?vue&type=template&id=4b4bce16"
import script from "./SistemaGrupoEdit.vue?vue&type=script&lang=js"
export * from "./SistemaGrupoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports